import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import '../styles/mentions.css';

const MentionsLegales = () => {
  return (
    <div className="mentions-container">
      {/* Header */}
      <header className="mentions-header">
        <div className="header-content">
          <Link to="/" className="logo-container">
            <div className="logo-image">
              <img 
                src="https://customer-assets.emergentagent.com/job_nature-health-2/artifacts/zktrrb9e_Logo%20chouquinette.png" 
                alt="Laura Body Logo" 
                className="logo-img"
              />
            </div>
            <div className="logo-text">
              <span className="logo-body">Laura Body</span>
              <span className="logo-nature">Reflexologue - Naturopathe</span>
            </div>
          </Link>
          <Link to="/">
            <Button className="btn-back">
              <ArrowLeft className="btn-icon" />
              Retour au site
            </Button>
          </Link>
        </div>
      </header>

      {/* Content */}
      <div className="mentions-content">
        <div className="mentions-inner">
          <h1 className="mentions-title">Mentions Légales</h1>
          <p className="mentions-subtitle">Laura Body Naturopathe Reflexologue Angoulême</p>

          <div className="mentions-intro">
            <p>
              Bienvenue sur le site de Laura Body naturopathe reflexologue, un espace dédié au bien-être naturel, 
              à la détente et à l'harmonie du corps. Conformément aux dispositions des articles 6-III et 19 de la 
              Loi n° 2004-575 du 21 juin 2004 pour la Confiance dans l'Économie Numérique (LCEN), ainsi qu'aux 
              exigences du Règlement Général sur la Protection des Données (RGPD) applicable depuis le 25 mai 2018, 
              nous mettons à votre disposition les informations légales suivantes concernant l'édition et l'hébergement 
              de ce site internet. Ces mentions légales s'appliquent à l'ensemble des pages du site 
              www.naturopathe-angouleme.fr et informent les utilisateurs des conditions générales d'utilisation du site.
            </p>
          </div>

          <section className="mentions-section">
            <h2>1. ÉDITEUR DU SITE</h2>
            <p>Le site naturopathe-angouleme.fr est édité par :</p>
            <ul>
              <li><strong>Laura Body</strong></li>
              <li>116 rue de Saintes 16000 Angoulême</li>
              <li>Téléphone : 06 50 15 59 23</li>
              <li>Adresse électronique : contact@naturopathe-angouleme.fr</li>
            </ul>
            <p>Si l'activité est enregistrée en tant qu'entreprise individuelle ou société :</p>
            <ul>
              <li>SIRET : 99904661800016</li>
              <li>RCS : Angoulême</li>
              <li>Code APE/NAF : 9609Z</li>
            </ul>
            <p>
              Laura Body, en sa qualité de directeur de la publication, est responsable de l'ensemble des contenus 
              mis à disposition sur le site. Pour toute question relative au site ou aux services proposés, vous 
              pouvez nous contacter à l'adresse email indiquée ci-dessus ou par courrier postal à l'adresse mentionnée.
            </p>
          </section>

          <section className="mentions-section">
            <h2>2. HÉBERGEUR DU SITE</h2>
            <p>Le site www.naturopathe-angouleme.fr est hébergé par :</p>
            <ul>
              <li><strong>OVH</strong></li>
              <li>2 rue Kellermann, 59100 Roubaix, France</li>
              <li>Site web : <a href="https://www.ovh.com/fr" target="_blank" rel="noopener noreferrer">https://www.ovh.com/fr</a></li>
            </ul>
            <p>
              Les données personnelles collectées sur ce site sont stockées sur des serveurs situés en France 
              et/ou dans l'Union européenne, conformément aux exigences du RGPD.
            </p>
          </section>

          <section className="mentions-section">
            <h2>3. PROPRIÉTÉ INTELLECTUELLE</h2>
            <p>
              L'intégralité des contenus présents sur le site www.naturopathe-angouleme.fr (textes, images, graphismes, 
              logos, vidéos, icônes, sons, bases de données, etc.) est protégée par le droit d'auteur et plus généralement 
              par la propriété intellectuelle, au sens des articles L.111-1 et suivants du Code de la propriété intellectuelle.
            </p>
            <p>
              Toute reproduction, représentation, modification, publication, adaptation ou exploitation partielle ou totale 
              des contenus, par quelque procédé que ce soit, sans l'autorisation écrite et préalable de Laura Body, est 
              strictement interdite et constituerait une contrefaçon au sens des articles L.335-2 et suivants du Code de 
              la propriété intellectuelle.
            </p>
            <p>
              Les marques naturopathe-angouleme.fr et son logo sont des marques déposées. Toute utilisation non autorisée 
              de ces marques ou de tout autre signe distinctif du site est interdite.
            </p>
          </section>

          <section className="mentions-section">
            <h2>4. COLLECTE ET TRAITEMENT DES DONNÉES PERSONNELLES</h2>
            <p>
              Dans le cadre de l'utilisation du site www.naturopathe-angouleme.fr, nous sommes amenés à collecter et 
              traiter certaines de vos données personnelles. Ces données sont traitées conformément au Règlement Général 
              sur la Protection des Données (RGPD) et à la loi française n° 78-17 du 6 janvier 1978 relative à l'informatique, 
              aux fichiers et aux libertés.
            </p>
            
            <h3>Finalités du traitement</h3>
            <p>Les données collectées (nom, prénom, adresse email, numéro de téléphone) le sont dans les finalités suivantes :</p>
            <ul>
              <li>Gestion des rendez-vous en ligne</li>
              <li>Relation client</li>
              <li>Envoi de newsletters et d'offres promotionnelles (uniquement si vous y avez consenti)</li>
              <li>Amélioration de nos services et personnalisation de votre expérience utilisateur</li>
              <li>Analyse statistique et mesure d'audience (via des outils comme Google Analytics)</li>
            </ul>

            <h3>Durée de conservation</h3>
            <p>
              Vos données sont conservées pendant une durée n'excédant pas celle nécessaire aux finalités pour lesquelles 
              elles sont collectées, soit 3 ans à compter de notre dernier contact pour les données clients.
            </p>

            <h3>Droits des utilisateurs</h3>
            <p>Conformément au RGPD, vous disposez des droits suivants :</p>
            <ul>
              <li><strong>Droit d'accès :</strong> Vous pouvez demander à consulter les données vous concernant.</li>
              <li><strong>Droit de rectification :</strong> Vous pouvez demander la correction de données inexactes ou incomplètes.</li>
              <li><strong>Droit à l'effacement :</strong> Vous pouvez demander la suppression de vos données, sous réserve des obligations légales de conservation.</li>
              <li><strong>Droit à la portabilité :</strong> Vous pouvez récupérer vos données dans un format structuré et couramment utilisé.</li>
              <li><strong>Droit d'opposition :</strong> Vous pouvez vous opposer au traitement de vos données pour des motifs légitimes.</li>
            </ul>
            <p>
              Pour exercer ces droits, vous pouvez nous contacter à l'adresse contact@naturopathe-angouleme.fr ou par 
              courrier postal à l'adresse indiquée ci-dessus. Vous avez également le droit d'introduire une réclamation 
              auprès de la CNIL (Commission Nationale de l'Informatique et des Libertés) si vous estimez que vos droits 
              ne sont pas respectés.
            </p>

            <h3>Cookies</h3>
            <p>
              Le site www.naturopathe-angouleme.fr utilise des cookies pour faciliter votre navigation, analyser l'audience 
              et personnaliser les contenus. Les cookies sont de petits fichiers texte déposés sur votre terminal (ordinateur, 
              tablette, smartphone) lors de votre visite sur le site.
            </p>
            <p>
              Vous pouvez désactiver les cookies à tout moment via les paramètres de votre navigateur. Pour plus d'informations 
              sur la gestion des cookies, consultez notre Politique de confidentialité.
            </p>
          </section>

          <section className="mentions-section">
            <h2>5. LIMITATION DE RESPONSABILITÉ</h2>
            <p>
              www.naturopathe-angouleme.fr s'engage à fournir des informations aussi précises que possible sur son site. 
              Toutefois, nous ne pouvons garantir l'exactitude, la complétude ou l'actualité des informations diffusées. 
              Les informations et descriptions des produits sont données à titre indicatif et ne sauraient engager notre 
              responsabilité.
            </p>
            <p>En aucun cas www.naturopathe-angouleme.fr ne pourra être tenue responsable :</p>
            <ul>
              <li>Des dommages directs ou indirects résultant de l'utilisation du site ou de l'impossibilité d'y accéder</li>
              <li>Des dommages résultant de l'utilisation des informations ou des produits présentés sur le site</li>
              <li>Des liens hypertextes pointant vers d'autres sites, dont le contenu ne saurait engager notre responsabilité</li>
            </ul>
            <p>L'utilisateur est seul responsable de l'utilisation qu'il fait des informations disponibles sur le site.</p>
          </section>

          <section className="mentions-section">
            <h2>6. LIENS HYPERTEXTES</h2>
            <p>
              Le site www.naturopathe-angouleme.fr peut contenir des liens hypertextes vers d'autres sites web. 
              www.naturopathe-angouleme.fr n'exerce aucun contrôle sur ces sites tiers et décline toute responsabilité 
              quant à leur contenu ou leur accessibilité.
            </p>
          </section>

          <section className="mentions-section">
            <h2>7. DROIT APPLICABLE ET LITIGES</h2>
            <p>
              Les présentes mentions légales sont régies par le droit français. Tout litige relatif à l'utilisation du 
              site www.naturopathe-angouleme.fr sera soumis aux tribunaux compétents de Angoulême, nonobstant pluralité 
              de défendeurs ou appel en garantie.
            </p>
          </section>

          <section className="mentions-section">
            <h2>8. CONTACT</h2>
            <p>
              Pour toute question relative aux présentes mentions légales, à la protection de vos données personnelles 
              ou à l'utilisation du site, vous pouvez nous contacter :
            </p>
            <ul>
              <li>Par email : contact@naturopathe-angouleme.fr</li>
              <li>Par courrier : 116 rue de saintes 16000 Angoulême</li>
            </ul>
          </section>

          <section className="mentions-section">
            <h2>9. MODIFICATION DES MENTIONS LÉGALES</h2>
            <p>
              Laura Body se réserve le droit de modifier les présentes mentions légales à tout moment, afin de les adapter 
              aux évolutions législatives, jurisprudentielles, éditoriales ou techniques. Les utilisateurs seront informés 
              des modifications par une mention sur le site ou par email, le cas échéant. Nous vous invitons à consulter 
              régulièrement cette page pour prendre connaissance des éventuelles mises à jour.
            </p>
            <p className="last-update"><strong>Dernière mise à jour : 17/01/2026</strong></p>
          </section>

          <div className="mentions-back-btn">
            <Link to="/">
              <Button className="btn-back-bottom">
                <ArrowLeft className="btn-icon" />
                Retour au site
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="mentions-footer">
        <p>&copy; 2025 Laura Body. Tous droits réservés.</p>
      </footer>
    </div>
  );
};

export default MentionsLegales;
